const actions = {
  SET_STATE: 'user/SET_STATE',
  CREATE: 'Percent/CREATE',
   EDIT: 'Percent/EDIT'
}

export default actions
